import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { useCurrentBreakpoint } from "./useCurrentBreakpoint";
import { useMemo } from 'react';
export function useResponsivePropValue(value, fallbackValue) {
  var currentBreakpoint = useCurrentBreakpoint();
  var result = useMemo(function () {
    if (_typeof(value) !== 'object') {
      return value;
    }
    if (!currentBreakpoint) {
      return fallbackValue;
    }
    if (value[currentBreakpoint]) {
      return value[currentBreakpoint];
    }
    var breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
    var index = breakpoints.findIndex(function (bp) {
      return bp === currentBreakpoint;
    });
    for (var i = breakpoints.length - 1; i >= 0; i--) {
      var bp = breakpoints[i];
      if (value[bp] && i <= index) {
        return value[bp];
      }
    }
    return fallbackValue;
  }, [currentBreakpoint, fallbackValue, value]);
  return result || fallbackValue;
}